/* src/app/customer-admin/customer-admin-feature/customer-admin-feature.component.scss */
/*# sourceMappingURL=customer-admin-feature.component.css.map */
